
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Brain, Sparkles } from "lucide-react";

interface RebrandingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RebrandingModal = ({ isOpen, onClose }: RebrandingModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full flex items-center justify-center">
              <Sparkles className="h-8 w-8 text-white" />
            </div>
          </div>
          <div className="text-2xl text-center font-medium text-slate-800">
            Agora SEO Score é <span className="font-bold">Page Score!</span>
          </div>
        </DialogHeader>
        
        <div className="text-center space-y-6 py-4">
          <p className="text-gray-600 leading-relaxed">
            Utilize a ferramenta e tenha insights gerados com{" "}
            <span className="font-semibold text-purple-600 inline-flex items-center gap-1">
              <Brain className="h-4 w-4" />
              Inteligência Artificial
            </span>{" "}
            para otimizar cada vez mais suas páginas.
          </p>
          
          <Button 
            onClick={onClose}
            className="w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold py-3"
          >
            Começar análise
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
